// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__8r3d6","resendInfoText":"OnGoingPaymentBox_resendInfoText__Vl5qn"};